import { authService } from "@/services/auth-service";
import { getUserRoleFlags } from "@/utils/user-utils";
import { computed } from "vue";

export function useLoggedInUserFlags(customerNumber?: string) {
  const flags = computed(() =>
    getUserRoleFlags(authService.loggedInUser, customerNumber),
  );

  const userIsUser = computed(() => flags.value.isUser);
  const userIsCustomerAdmin = computed(() => flags.value.isCustomerAdmin);
  const userIsOneAdmin = computed(() => flags.value.isOneAdmin);
  const userIsOneUser = computed(() => flags.value.isOneUser);
  const userIsOneUserAdmin = computed(() => flags.value.isOneUserAdmin);

  return {
    userIsUser,
    userIsCustomerAdmin,
    userIsOneAdmin,
    userIsOneUser,
    userIsOneUserAdmin,
  };
}
